import React, { useEffect, useState, useCallback } from "react";
import { CountUp } from "use-count-up";
import axios from "axios";
import { Checkbox } from "antd";
import { If, Then, Else } from "react-if";
import { comma } from "../Func.js";
import { floor } from "lodash";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css

function StakingListModal({
  refreshPage,
  address,
  profitData,
  userInfo,
  creta,
  setLoading,
  setStakingModalOpen,
}) {
  const [stakingData, setStakingData] = useState([]);

  const getStakingList = useCallback(async () => {
    // setLoading(true);
    axios
      .post("api/getStakingHistory", {
        address: address,
      })
      .then((res) => {
        console.log(res.data);
        setStakingData(res.data);
        // setLoading(false);
      })
      .catch((err) => {
        // setLoading(false);
        if (err.response) {
          console.log(err.response);
        }
      });
  }, [setLoading, setStakingData]);

  const collect = useCallback(
    async (id) => {
      setLoading(true);
      axios
        .post("api/collectStaking", {
          address,
          id,
        })
        .then((res) => {
          alert("Processed successfully.");
          console.log(res.data);
          setLoading(false);
          getStakingList();
          // refreshPage();
          // setStakingModalOpen(false);
        })
        .catch((err) => {
          alert(err.response.data.message);
          setLoading(false);
          if (err.response) {
            console.log(err.response);
          }
        });
    },
    [setLoading, getStakingList]
  );

  const cancelConfirm = async (id) => {
    const msg =
      "If you cancel your staking now, you won't receive any interest.\nPlease be advised, once you cancel, it will be irreversible.";

    confirmAlert({
      title: "Confirm",
      message: msg,
      buttons: [
        {
          label: "Yes",
          onClick: () => cancel(id),
        },
        {
          label: "No",
          onClick: () => {},
        },
      ],
    });
  };
  const cancel = async (id) => {
    setLoading(true);
    axios
      .post("api/cancelStaking", {
        address,
        id,
      })
      .then((res) => {
        alert("Processed successfully.");
        console.log(res.data);
        setLoading(false);
        // getStakingList();
        refreshPage();
        setStakingModalOpen(false);
      })
      .catch((err) => {
        alert(err.response.data.message);
        setLoading(false);
        if (err.response) {
          console.log(err.response);
        }
      });
  };

  useEffect(() => {
    getStakingList();
  }, [getStakingList]);

  return (
    <div className="modal-body">
      <h2 className="mb-3">Staking List</h2>

      <div className="flex-center">
        <table className="history-table">
          <thead>
            <tr>
              <th>Type</th>
              <th>
                Start
                <br />
                Date
              </th>
              <th>
                Amount
                <br />
                (CRETA)
              </th>
              <th>
                Interest
                <br />
                (CRETA)
              </th>
              <th>
                Remain
                <br />
                (days)
              </th>
            </tr>
          </thead>
          <tbody>
            {stakingData?.map((row, index) => (
              <tr key={index}>
                <td width={"20%"} className="date text-center color-gold">
                  {row.staking_days} DAYS
                </td>
                <td width={"25%"} className="date text-center">
                  {row.created_at}{" "}
                </td>
                <td width={"18%"} className="date text-center">
                  {comma(row.amount)}{" "}
                </td>
                <td width={"18%"} className="title text-center">
                  {comma(row.current_interest)}{" "}
                </td>
                <td width={"18%"} className="title text-center">
                  <If condition={row.remain > 0}>
                    <Then>
                      {row.remain}
                      <button
                        className="btn btn-sm btn-dark btn-shadow"
                        onClick={() => cancelConfirm(row.id)}
                      >
                        Cancel
                      </button>
                    </Then>
                    <Else>
                      <button
                        className="btn btn-md btn-primary"
                        onClick={() => collect(row.id)}
                      >
                        Collect
                      </button>{" "}
                    </Else>
                  </If>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <hr />
      <div className="flex-space-between mt-1">
        <div></div>
        <button
          className="btn btn-md btn-secondary"
          onClick={() => setStakingModalOpen(false)}
        >
          close
        </button>
      </div>
    </div>
  );
}

export default StakingListModal;
